import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

export const placeholders = defineMessages({
    passwordPlaceholder: {
        id: 'dbl.authmodal.auth.passwordPlaceholder',
        defaultMessage: 'Password',
    },
    emailPlaceholder: {
        id: 'dbl.authmodal.auth.emailPlaceholder',
        defaultMessage: 'Email address',
    },
    passwordConfPlaceholder: {
        id: 'dbl.authmodal.auth.passwordConfPlaceholder',
        defaultMessage: 'Re-enter new password',
    },
    createPasswordPlaceholder: {
        id: 'dbl.authmodal.auth.completeEmailOnly.passwordPlaceholder',
        defaultMessage: 'Create a password',
    },
});

export const privacyPolicyLink = (
    <a href="/about/privacy-policy/" target="_blank">
        <FormattedMessage
            id="dbl.authmodal.auth.acceptPolicyContactDealer.privacyPolicy"
            defaultMessage="Privacy Policy"
        />
    </a>
);
export const userAgreementLink = (
    <a href="/about/user-agreement/" target="_blank">
        <FormattedMessage
            id="dbl.authmodal.auth.acceptPolicyContactDealer.userAgreement"
            defaultMessage="User Agreement"
        />
    </a>
);

export default {
    acceptPolicyContactDealer: (
        <FormattedMessage
            id="dbl.authmodal.auth.acceptPolicyContactDealer"
            defaultMessage="I accept the 1stdibs' {privacyPolicyLink} and {userAgreementLink}, and understand that sharing contact information to purchase outside of 1stdibs is prohibited."
            values={{
                privacyPolicyLink,
                userAgreementLink,
            }}
        />
    ),
    accountLogin: (
        <FormattedMessage
            id="dbl.authmodal.auth.accountLogin"
            defaultMessage="Already have an account?"
        />
    ),
    continue: <FormattedMessage id="dbl.authmodal.auth.continue" defaultMessage="Continue" />,

    login: <FormattedMessage id="dbl.authmodal.auth.login" defaultMessage="Log in" />,

    passwordLength: (
        <FormattedMessage
            id="dbl.authmodal.auth.passwordLength"
            defaultMessage="Must be at least 5 characters"
        />
    ),
    register: <FormattedMessage id="dbl.authmodal.auth.register" defaultMessage="Sign up" />,
    resetPassword: (
        <FormattedMessage
            id="dbl.authmodal.auth.resetPassword"
            defaultMessage="Reset or Create Password"
        />
    ),
    submit: <FormattedMessage id="dbl.authmodal.auth.submit" defaultMessage="Submit" />,
    welcome: (
        <FormattedMessage id="dbl.authmodal.auth.welcome" defaultMessage="Welcome to 1stdibs" />
    ),
    createPassword: {
        header: (
            <FormattedMessage
                id="dbl.authmodal.auth.createPassword.header"
                defaultMessage="Create Password"
            />
        ),
        viewConversationsHeader: (
            <FormattedMessage
                id="dbl.authmodal.auth.createPassword.viewConversationsHeader"
                defaultMessage="Create Password to View Conversations"
            />
        ),
        viewOrdersHeader: (
            <FormattedMessage
                id="dbl.authmodal.auth.createPassword.viewOrdersHeader"
                defaultMessage="Create Password to View Orders"
            />
        ),
        acceptOfferHeader: (
            <FormattedMessage
                id="dbl.authmodal.auth.createPassword.acceptOfferHeader"
                defaultMessage="Create an Account to View Your Offer"
            />
        ),
        checkoutHeader: (
            <FormattedMessage
                id="dbl.authmodal.auth.createPassword.checkoutHeader"
                defaultMessage="Create Password to Purchase Now"
            />
        ),
        requestShippingQuoteHeader: (
            <FormattedMessage
                id="dbl.authmodal.auth.createPassword.requestShippingQuoteHeader"
                defaultMessage="Create Password to Request Shipping Quote"
            />
        ),
        viewInvoiceHeader: (
            <FormattedMessage
                id="dbl.authmodal.auth.createPassword.viewInvoiceHeader"
                defaultMessage="Create Password to View Invoice"
            />
        ),
        callSellerHeader: (
            <FormattedMessage
                id="dbl.authmodal.auth.createPassword.callSellerHeader"
                defaultMessage="Create Password to Call the Seller"
            />
        ),
        sendMessageHeader: (
            <FormattedMessage
                id="dbl.authmodal.auth.createPassword.sendMessageHeader"
                defaultMessage="Create Password to Send Your Message"
            />
        ),
    },
    saveItem: {
        subtitle: (
            <FormattedMessage
                id="dbl.authmodal.auth.saveItem.subtitle"
                defaultMessage="We'll alert you when it goes on sale."
            />
        ),
    },
    trade: {
        welcome: (
            <FormattedMessage
                id="dbl.authmodal.auth.trade.welcome"
                defaultMessage="Complete Your Application"
            />
        ),
    },
    errors: {
        conflictRegistration: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.conflictRegistration"
                defaultMessage="This email address has already been registered. Please enter your password to login."
            />
        ),
        emailInvalid: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.emailInvalid"
                defaultMessage="Please enter a valid email address."
            />
        ),
        emailRequired: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.emailRequired"
                defaultMessage="Email address is required."
            />
        ),
        invalidLogin: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.invalidLogin"
                defaultMessage="The email/password combination does not match our records. Passwords are case sensitive."
            />
        ),
        invalidResetToken: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.invalidResetToken"
                defaultMessage="The link to reset your password is invalid. Please make sure that:<ul><li>The link was requested within the last 24 hours</li><li>The link has not been used before to reset your password</li><li>The link is spelled correctly</li><li>If a reset was requested multiple times, this is the most recently sent link</li></ul>"
            />
        ),
        nonSupportedTradeLogin: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.nonSupportedTradelogin"
                defaultMessage="The 1stdibs trade experience is not yet supported on this domain. Please log in at {usHomepage} or {gbHomepage}."
                values={{
                    usHomepage: (
                        <a href="https://www.1stdibs.com/">
                            <FormattedMessage
                                id="dbl.authmodal.auth.errors.usHomepage"
                                defaultMessage="1stdibs.com"
                            />
                        </a>
                    ),
                    gbHomepage: (
                        <a href="https://www.1stdibs.co.uk/">
                            <FormattedMessage
                                id="dbl.authmodal.auth.errors.gbHomepage"
                                defaultMessage="1stdibs.co.uk"
                            />
                        </a>
                    ),
                }}
            />
        ),
        passwordMatch: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.passwordMatch"
                defaultMessage="The passwords do not match. Please check the passwords that you entered."
            />
        ),
        passwordRequired: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.passwordRequired"
                defaultMessage="Password is required."
            />
        ),
        passwordShort: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.passwordShort"
                defaultMessage="Please enter a minimum of 5 characters."
            />
        ),
        support: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.support"
                defaultMessage="Authentication error! Please contact {mailLink}"
                values={{
                    mailLink: <a href="mailto:support@1stdibs.com">support@1stdibs.com</a>,
                }}
            />
        ),
        socialLoginOnly: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.socialLoginOnly"
                defaultMessage="You've registered through Facebook. Continue with Facebook below."
            />
        ),
        socialLoginNoEmailReturned: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.socialLoginNoEmailReturned"
                defaultMessage="Your Facebook account needs a valid email to continue. Please try again with an alternative Facebook login."
            />
        ),
        emailOnlyCreatePassword: (
            <FormattedMessage
                id="dbl.authmodal.auth.errors.emailOnlyCreatePassword"
                defaultMessage="Please click on the link below to create a password for this account."
            />
        ),
    },
    designerConnectionModal: {
        subText: (
            <FormattedMessage
                id="dbl.authmodal.auth.designerConnectionModal.subText"
                defaultMessage="We'll start matching you with award-winning designers"
            />
        ),
    },
};
